<template>
  <div>
    <div class="vg-content">
      <template v-if="state === 'OK'">
        <van-image class="logo" width="100" height="50" :src="srcLogo"/>
        <van-image style="margin-top: 110px;" width="100" height="100" :src="srcSuccess"/>
        <div class="text" style="margin-top: 40px;">支付成功</div>
      </template>
      <template v-else>
        <van-image class="logo" width="100" height="50" :src="srcLogo"/>
        <van-image style="margin-top: 110px;" width="100" height="100" :src="srcFailed"/>
        <div class="error" style="margin-top: 40px;">该订单已完成支付</div>
        <div class="error" style="margin-top: 10px;">请勿重复扫描</div>
      </template>
    </div>
    <vg-button-group v-if="state === 'OK'">
      <vg-button type="primary" @click="onSubmit">返回首页</vg-button>
    </vg-button-group>
  </div>
</template>

<script>
import {Image as VanImage} from "vant";
import srcLogo from "@/assets/login/kaidelogo.png";
import srcSuccess from "@/assets/scanverify/pay-success.svg";
import srcFailed from "@/assets/scanverify/pay-failed.svg";
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed";

export default {
  name: "ChargeState",
  components: {
    VanImage, VgButton, VgButtonGroup,
  },
  data() {
    return {
      srcLogo: srcLogo,
      srcSuccess: srcSuccess,
      srcFailed: srcFailed,
      state: "",
    }
  },
  created() {
    console.log(this.$route);
    this.state = this.$route.query.state;
  },
  methods: {
    onSubmit() {
      this.$router.go(-1);
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.logo {
  align-self: flex-start;
}

.text {
  color: #4BA9F6;
  font-size: 36px;
  font-weight: bold;
}

.error {
  color: #4BA9F6;
  font-size: 30px;
  font-weight: bold;
}
</style>